<div class="media alert alert-warning" *ngIf="showFraudLanguage">
    <div class="media-left">
        <span class="nw-icon-warning"></span>
    </div>
    <div class="media-body" [style.font-size]="fontSize" [style.fontFamily]="fontFamily" [style.font-weight]="'bold'">
        {{language}}
    </div>
</div>